var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStampsold01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 8192 3575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient-10);\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient-9);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-28);\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-14);\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: url(#radial-gradient-16);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient-18);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-9 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-10 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-11 {\n        fill: url(#radial-gradient-24);\n      }\n\n      .cls-12 {\n        fill: url(#radial-gradient-20);\n      }\n\n      .cls-13 {\n        fill: url(#radial-gradient-29);\n      }\n\n      .cls-14 {\n        fill: url(#radial-gradient-11);\n      }\n\n      .cls-15 {\n        fill: url(#radial-gradient-26);\n      }\n\n      .cls-16 {\n        fill: url(#radial-gradient-8);\n      }\n\n      .cls-17 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-18 {\n        fill: url(#radial-gradient-23);\n      }\n\n      .cls-19 {\n        fill: url(#radial-gradient-27);\n      }\n\n      .cls-20 {\n        fill: url(#radial-gradient-30);\n      }\n\n      .cls-21 {\n        fill: url(#radial-gradient-21);\n      }\n\n      .cls-22 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-23 {\n        fill: url(#radial-gradient-25);\n      }\n\n      .cls-24 {\n        fill: url(#radial-gradient-22);\n      }\n\n      .cls-25 {\n        fill: url(#radial-gradient-12);\n      }\n\n      .cls-26 {\n        fill: url(#radial-gradient-19);\n      }\n\n      .cls-27 {\n        fill: url(#radial-gradient-31);\n      }\n\n      .cls-28 {\n        fill: url(#radial-gradient-15);\n      }\n\n      .cls-29 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-30 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-31 {\n        fill: url(#radial-gradient-17);\n      }\n\n      .cls-32 {\n        fill: url(#radial-gradient-13);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 8126.6,
    cy: 2383.2,
    fx: 8126.6,
    fy: 2383.2,
    r: 404.6,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 7431.1,
    cy: 2311.4,
    fx: 7431.1,
    fy: 2311.4,
    r: 381.9,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 6622.7,
    cy: 2244.2,
    fx: 6622.7,
    fy: 2244.2,
    r: 417.5,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 5863.5,
    cy: 2153.7,
    fx: 5863.5,
    fy: 2153.7,
    r: 426.7,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 1340.9,
    cy: 2457.9,
    fx: 1340.9,
    fy: 2457.9,
    r: 377.2,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 2151,
    cy: 1138.1,
    fx: 2151,
    fy: 1138.1,
    r: 165.9,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 859.8,
    cy: 1027.3,
    fx: 859.8,
    fy: 1027.3,
    r: 752.3,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 2655.4,
    cy: 1186.6,
    fx: 2655.4,
    fy: 1186.6,
    r: 213.1,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 2122.4,
    cy: 1092.1,
    fx: 2122.4,
    fy: 1092.1,
    r: 10.3,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 32.8,
    cy: 1670.6,
    fx: 32.8,
    fy: 1670.6,
    r: 775.4,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 3000.6,
    cy: 2603.2,
    fx: 3000.6,
    fy: 2603.2,
    r: 775.9,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 748.7,
    cy: 2350.4,
    fx: 748.7,
    fy: 2350.4,
    r: 0.3,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 313.8,
    cy: 1669,
    fx: 313.8,
    fy: 1669,
    r: 392.4,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 675.2,
    cy: 1421,
    fx: 675.2,
    fy: 1421,
    r: 137.5,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 1152.9,
    cy: 1759.6,
    fx: 1152.9,
    fy: 1759.6,
    r: 417.5,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 1954.2,
    cy: 2007.5,
    fx: 1954.2,
    fy: 2007.5,
    r: 281.3,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 1996.5,
    cy: 1633.8,
    fx: 1996.5,
    fy: 1633.8,
    r: 293,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 2678.8,
    cy: 1902.1,
    fx: 2678.8,
    fy: 1902.1,
    r: 421.9,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 3461.8,
    cy: 1955.8,
    fx: 3461.8,
    fy: 1955.8,
    r: 396,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 3942.2,
    cy: 2243,
    fx: 3942.2,
    fy: 2243,
    r: 149.5,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 4284.6,
    cy: 2011.9,
    fx: 4284.6,
    fy: 2011.9,
    r: 409.5,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 5195.6,
    cy: 2536.3,
    fx: 5195.6,
    fy: 2536.3,
    r: 28.1,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 5099.8,
    cy: 2099.4,
    fx: 5099.8,
    fy: 2099.4,
    r: 435.6,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 6737.3,
    cy: 2927.2,
    fx: 6737.3,
    fy: 2927.2,
    r: 133.6,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 7594.1,
    cy: 1617.8,
    fx: 7594.1,
    fy: 1617.8,
    r: 325.7,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 8797.2,
    cy: 2397.1,
    fx: 8797.2,
    fy: 2397.1,
    r: 649.7,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 5315.2,
    cy: 2805.9,
    fx: 5315.2,
    fy: 2805.9,
    r: 859,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 8160,
    cy: 1667.3,
    fx: 8160,
    fy: 1667.3,
    r: 86.4,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 7893.2,
    cy: 3029.2,
    fx: 7893.2,
    fy: 3029.2,
    r: 699.2,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 9086.6,
    cy: 2269.1,
    fx: 9086.6,
    fy: 2269.1,
    r: 16.1,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 5045.6,
    cy: 1395.1,
    fx: 5045.6,
    fy: 1395.1,
    r: 1482.1,
    gradientTransform: "translate(808.9 3453.1) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e42e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e0262c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d9181c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce0506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M7587.2,1007.4L554.6,1623.1c-173.5,15.2-309.1,84.9-302.9,155.8l78.3,894.8c6.2,70.8,151.9,116,325.4,100.8l7032.6-615.7c173.5-15.2,309.1-84.9,302.9-155.8l-78.3-894.8c-6.2-70.8-151.9-116-325.4-100.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M7016.4,1417.7l32.7,369c1.7-2.2,3.5-4.4,5.5-6.5,15.2,22.7,17.1,42.4,12,61.2,1.3,8.1-1.5,16.4-8.9,22.2-.5,1-1,1.9-1.5,2.9l8.6,97.4,152.4-13.5-48.4-546.2,185.5-16.4-11.3-127.8-523.4,46.4,11.3,127.8,185.5-16.4h0ZM7289.2,1358.7c-15.2-.7-15.7-10.9-16.5-19.6,8.6,1.4,17.1,3.4,25.5,6.4-3.1,4.6-5,13.5-9,13.3h0ZM7271.4,1289.8c3.2-7.7,14.5-16.1,24.1-15.7,12.6.6,21.1,12.3,22.8,23.7-1.6,11.7-13.3,15.1-25.3,13.4-12.6-1.8-26.2-10.7-21.5-21.4h0ZM7188.7,1934.6c-19.2-11-31.2-21.8-36.7-32.8-9.2,9.9-22,13.9-41.5-1.3-16-12.5-1.9-20.9,13.7-23.2,8,2.8,16.1,5.5,24.2,8.3.5-10,6.1-20.2,15.9-30.7,35.3,26.6,53.8,51.8,24.3,79.6h0ZM7105.3,1540c8.9-2.4,14.7,1.1,17.4,9.6,3.5,9.9,1.8,17.3-10.1,19.8-6.6-3.4-17.3-6.1-19.4-10.3-4.8-9.7,1.6-16.3,12.1-19.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M6367.5,1526.5c3.5,5.5,7.1,11,10.5,16.6.5,11.3-6.2,17.9-20,15.9-2.8-.4-5.7-1.1-8.4-2l22.7,255.7c6.7-45.9,19.4-91.7,48.7-135.7,19.2,131.5-13.5,236.6-21.6,345.8l144-12.8-23.2-262.2,233.2-20.7-11.3-127.8-233.2,20.7-13.8-156.3,273-24.2-11.3-127.8-74.9,6.6c-3.2,4.7-8.3,9.7-13.1,16.7-4.3-5.3-8.4-10-12.3-14.4l-188.5,16.7c2.9,4,5.6,7.9,5.8,11.5.6,8.9-5,16.8-17.9,14-3.8-.8-7.1-10.7-12.1-18.7,2.8-1.7,5.7-3.6,8.7-5.4l-121,10.7,16.4,185.1c5.9-3.1,13.6-5.2,19.8-8.1h0ZM6481.3,1419.4c2.7,7.1,5.4,13,6.5,18.8.2,1.2-8.4,3.4-8.9,2.9-4.1-4.2-10.2-9.7-10-13.6.1-3.4,7.7-5.3,12.4-8.2h0ZM6477.3,1587.8l2,9.5-2.2,8.8c-5.6-4-11.2-8.1-16.6-12.1,5.5-2,11.2-4.1,16.7-6.1h0ZM6395.7,1455.8c3.8-.7,16.1,6.6,17.2,10.4,3,9.7,3.8,19.3-2.3,26,8.2,3.1,16.8,11.1,24.8,22.1-2.5,19.4-4.9,38.9-7.5,58.3-37.5-15.8-55.9-39.3-43.1-66.4,2.3-4.7,4.8-8.3,7.5-10.7-4.8-2.5-9.6-5-10.2-7.5-3.4-13.6-5.3-28.3,13.5-32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M6062.1,1753.7c10.4,117.4-19.8,169.5-79.9,184.3,1.6,3.5,3,6.9,2.6,9.9-.5,3.9-7.3,6.2-12.5,9.8-2.7-6.8-5.9-12.2-6.9-16.6-2.3.3-4.6.5-7,.8-75.4,6.7-121-35.3-132.7-167.2l-16.4-185.5c-4,13-8.8,25.8-14.4,38.4-25,55.2,1.3,128.1-40,179.9,1.9-119.9,4.7-239.6,42.8-349.9l-5.3-60.2-152.4,13.5,32.1,361.7c20.1,226.3,123.8,316.3,298.2,300.9s257.6-122.1,237.6-348.4l-32.1-361.7-146.9,13,33.4,377.3h0ZM5798.7,2019.7c-1.6.6-4.8-.7-7.3-1.2-1.3-2.4-4-5.4-3.4-6.9,1-2.3,6-5.3,7-4.8,9,5.4,10.4,10.3,3.7,13ZM5841.4,2016.7c-13.9-3.6-17.5-14.1-16-22.9.9-5.3,7.9-13.6,11.3-12.7,13.8,3.4,16.5,13.3,16.7,23-4.1,4.5-8.7,13.6-12,12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M5231.7,1964.6c3.3-12.8,12-23.3,31.3-16.1,7.8,2.9,12.4,7.1,15,11.9l146.5-13,55.7,156.9,161.3-14.3-76.5-184.6c-54.4,4.8-93.6-21.5-136.8-55,52.7-15.5,91.9-11.8,121.7,18.5l-179.8-434.2-182.3,16.2-152,692.8,155.8-13.8,27.4-164.2,12.7-1.1h0ZM5601.2,2041.6c4.9,8.5,9.9,17.1,14.3,24.7-7,5.2-12,8.8-16.8,12.4-4-8.6-10.2-17.5-10.8-25.7-.4-4.4,8.6-7.6,13.4-11.5ZM5292.8,1463.1l2.1-1.2c-.2.8-.6,1.6-.9,2.3,43,33.7,20.3,54.9,3.7,90.3-36.7-45.9-12-66.6-3.7-90.3-.6-.4-.6-.7-1.2-1.1ZM5283.7,1558.6l4.1-.4c8.3,23.4,16.6,48,25,72.8,14.3-27.9,29.3-45.4,71.1-22.7,6.4,3.4,14.1,12.9,13.7,17.9-2.8,35.5-44.8,10.5-66.6,17.3-1.9.7-5.6-1.3-15.5-4.7,15.4,45.3,30.9,91,46.3,132l21.6,61-144.2,12.8,10.7-63.8c12.8-69.1,23.8-149.5,33.8-222.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2041.5,1581.1c-.2,0-.4,0-.5,0-6.1-1.2-11-5.6-17-8.9,4.7-2.6,10-7.4,13.9-6.8,5.9.8,10.7,5.4,15.9,8.3-3.8,2.3-8.6,7-11.9,7.4l189.3-16.6c2.7-6.8,5.5-13.6,8.4-20.4,3-16.8,6-33.7,9.5-50.4-1.4-6.4-1.8-12.7-1.4-18.9l-182,15.9c-1.9,13.3-9.2,23-29.4,24.3-12.9,6.5-24.8,15.1-39,18.9-13,3.5-33.3,13.3-41-.5-4.2-7.3,10.3-20.3,16.5-30.7-.5-1.3-.9-2.5-1.3-3.8l-507.9,44.5c-7.5,16.7-14.3,33.6-18.1,50.8-1.6,13.1-3.3,26.3-5.2,39.4l601.2-52.6h0ZM1758.8,1528.7l6.2-2.9h0c6.8,3.1,14.6,5.5,20.1,9.4,15.7,11.4,22.3,24.5,10.5,39.8-2,2.3-7.5,5.6-9.7,5.1-21.6-5.4-29.6-18-30.1-33.7-.4-5.9,1.7-11.8,2.9-17.7h0ZM1634.4,1564.5c34.4-5.4,60.2,3.5,80.5,34.5-11.8,3.7-15.9,6.2-19.1,5.7-28.4-4-64.8,2.6-74.2-27.6-1.2-3.5,7.2-11.8,12.8-12.6h0ZM1534,1601.8c.7-9.6,11.1-17.1,21.9-16.2,16.7,1.2,28.6,9.3,21.4,23.8-4.3,8.9-14.2,12.5-23.9,10.7-19-1.1-20.2-9.9-19.4-18.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2609.4,2537.4c-10.7,12.6-22.7,25-35.7,37.1,8.1-18.4,11.4-37.9,14.2-57.4l-277,24.2c-.1,2.6-.3,5.3-.4,7.9-4,27.1-8,54.3-12,81.4l123.9-10.8c.2-4,3.1-7.7,9.4-10.7,4.5-19-7.4-42.3,25.5-54.2,8.4,9.2,8.7,17.1,5.6,24.4,4.3-.9,8.2,1.1,13.1,5.2,11.5,9.2,15.3,18.9,13.9,29.4l152.8-13.4c-19.4-21.2-29.2-42-33.3-63.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2286.9,2563.1c-4.4-5.7-7.2-11.4-8.9-17-2.3.5-4.6.9-6.4,1.5-.2-.9-.5-1.8-.8-2.8l-70,6.1c-1.1,3.3-2.3,6.5-3.4,9.7,1.4,10.9,4.8,23.7-12.1,28.4-10.9,3-18.6-5-20.8-13.7-2.9-7.1-4.9-14-6.2-20.7l-1157,101.3c-4.2,11.4-5.6,26.7-30.6,16-8.1-3.5-12.5-7.6-14.4-12.1l-97.6,8.5c0,0,0,.1,0,.2-2.3,8.6-11.3,17-24.7,14.5-8.8-1.7-11.3-6.3-11.4-11.5l-72.7,6.4c-21.7,1.9-42.3,1.6-60.8-.5-6.9,28.4-23.5,55.5-29.6,84,0,4.3-.1,8.5-.5,12.7l971.9-85.1c2.9-3.1,6.6-6.2,11-9.1,7.9.5,12.3,3.2,15.1,6.8l135.7-11.9c-.6-.9-1.2-1.8-1.8-2.8,3.2-1.4,6.4-2.8,9.8-4.1,1.2,1.9,3.6,4,4.3,5.8l79.4-7c18.3-15.1,35-16.5,55-4.8l322.2-28.2c9.2-23.5,18.9-46.9,25-70.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2922.7,2498.6c-10.2-1-17.3-4.3-21.3-9l-265.3,23.2c22.2,23.6,33.8,50.6,23.9,86.1l401.7-35.2c1.1-23,4.6-45.6,22.9-65.5-.2-8.2-1-16.4-1.6-24.5l-156.3,13.7c-1.3,3.7-2.6,7.5-3.9,11.2h0ZM2728,2541.9c-9.2-4-12.5-15-17.2-21.3,1.7-3.8,4.7-5.7,7.5-8.3,6.5-6.1,14.1-9.9,21.4-6.6,4.3,1.8,7.8,5.7,10.5,10.2,2.3,4.4,3.9,9.2,3.9,13.3-.2,10.1-14.6,17.5-26.1,12.7h0ZM2896.8,2546.8c-.6,3.2-4.4,6-7.9,8.8-1.2.9-2.2,1.7-3.2,2.5-3.3-3.3-10.4-7.3-9.6-10,1.3-4.3,7.7-7.8,11.9-11.7,1.4,1.6,3.5,3.2,5.3,4.9,2.2,1.9,3.9,3.8,3.5,5.4h0ZM2896.2,2511.3c-5.4,3-14.1,2.6-21.2,3.8-2.2-4.8-7.6-10.5-6-14.5,5-10.1,15.6-8.8,25.9-3.4,7.7,3.9,9.2,9.6,1.2,14.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2447.4,2600.8c-2.5,3.3-4.8,6.6-6.3,10,2,2.5,2.9,4.9,3,7l11.8-1c-3.8-5.2-7.5-10.5-8.5-16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M624.8,2776.5c3.4-5.6,5.5-12.3,5.9-20.4-16.9-19.8-2.3-38.1,5.4-56.6,2.8-11.3,2.8-23.1,2.8-34.9-16.6-7.6-26.9-17.8-28-29.8l-75.9-866.7c-2.6-30.3,55.3-60.1,129.5-66.6l382.6-33.5c7-13.8,13.9-27.6,20.8-41.4,6.1,2,12.2,4,18.1,6.1-7.4,9.1-6.5,21.4-8.4,32.6l308.9-27c.1-.3.2-.6.3-.9,8.5-7.6,16.8-15.2,25.3-22.8l-2.3-.4c0-.2.1-.4.2-.6,2.7-22,4.4-44.1,6.8-66.1l-412.9,36.1c7.8,3.6,15,8.3,21.3,14.4-5.2,4-9.2,8.7-11.4,14-23.5,4.4-47,8.8-70.4,13.1,8.1,26.1-12.9,35.7-41.3,45.6-34.5,12-70.6,14.1-80.9-13.3-13.8-37.3,35.8-24.9,61.1-31.3-13.2-7.8-24.3-16.7-28-29.5l-299.8,26.2c-26.8,2.3-52.7,6-77.3,10.7,24.6,13.6,28.7,28.6,20.2,50.7-5.3,13.6-13.4,30.7-36.5,31.8-23.4,1.2-38.1-13.1-36.4-28.7,1.3-13.7-4.9-25.5-12.3-37.9-24.4,7.4-46.8,16-66.6,25.4,9.7,1.5,12.9,8.4,12,15.7-1.1,8.1-6.4,16.8-20.4,11.1-7.1-2.9-12.5-7.9-18.3-12.7-44.6,26.5-70.2,57.9-67.4,89.6l16,182.7c32.9-32.1,57.8-51.9,107.2-39.9,6.1,30.2-8.1,57-23.3,86.5-46-1.6-31.6-48.5-83.7-44.7l62.2,710.2c5.8,66.6,135.1,110.5,294.8,102.8h0ZM708.7,1631.4c.2-.6,0-1.3.3-1.9l1.1,1.3c-.5.1-.8.4-1.4.5-4.8,15.1,6.6,33.8-17.6,44.1-2.9,1.3-15.6-3.6-16.4-6.6-5-20.2,12.3-30.1,34-37.5h0ZM581.7,1642.9c-3.9,11.3-12.3,16.6-28.5,11,9.2-4.1,18.7-7.8,28.5-11ZM549.9,1720.2c2.9-7,9.4-13.1,15.3-20.5,6,5.4,14.4,10.2,13.2,12.2-3.8,6.7-10.8,12.5-16.8,18.5-4-3.4-12.5-7.8-11.7-10.2h0ZM304.2,1882.7c-14.8-13.7-30.2-23.7-38.4-36.3-11.9-18.4,0-38.7,22.4-43.2,37.4-7.6,29.4,17.8,31.2,33.1,1.5,13.6,10.5,28.4-15.2,46.4h0ZM415.7,1821.3c3.9-11.8,12.4-20.6,32.7-14.2,16.8,5.3,39.7,5.4,36.1,25.2-8.8,15.3-26.2,24.1-45.5,22-23.3-2.4-28.2-17.9-23.3-33h0ZM375.5,1875c-3.8,7.4-9.1,19.6-23.9,11.4-6.6-3.7-5.1-15.4-7.3-23.4,4.3-8,8.7-15.9,12.9-23.9-26.7-7.6-9.3-23.2-11.8-35.1,34.7-7.4,15.4,12,18.7,20.2,13.6,15.8,20.4,32.7,11.4,50.8h0ZM338.4,2417.3c4.6.5,12.1,6.9,11.4,9.6-1.4,4.6-8.2,8.4-12.9,12.9-3.7-3.8-8.7-7.2-10.5-11.3-3-6.9,2.2-12.2,11.9-11.1h0ZM327.9,2649.9c13.3-19,28.7-30.6,53.1-7.7-13.3,18.4-32.8,15-53.1,7.7ZM375.1,2253.2c-9.3-4.1-17.9-9.7-26.7-14.8,3.6-1.3,7-3.4,10.7-4,11.6-1.5,24-3.5,28.4,9.2-4,3.2-11.2,10.2-12.5,9.6h0ZM359.6,2098.5c6.3-21.9,24.8-37.2,57.7-30.9,8.3,1.6,15.3,4.9,20.2,9.8-2.9-4.4-3.4-9.5.5-15.7,5.4-8.6,17-12.8,27.3-4.1,7.2,6.1,14.2,14.7,14.6,22.3.3,9.8-10.4,14.5-24.8,10.8-5.7-3-11.1-6.2-14.9-10,4.5,6.4,6.1,15,3.8,26-4.9,17.4-27.8,30.3-56.2,30.1-31.8-.2-33.2-20.9-28.3-38.3h0ZM393,2680.7c4.2-8.6,13.8-10.6,24.7-10.6-.5,13.3-11.4,13.4-24.7,10.6h0ZM416,2386c-18-4.6-26.5-17.8-20-27,8.9-12.3,30.2-18,50.4-15.7,14.9,1.7,13.8,12.1,11.2,20.2-5,15.8-17.5,25.1-41.6,22.5h0ZM434.3,2416.5c-1.9-9.4,5.5-15.8,17.8-18.5,1.1-.2,5.1,4.4,5.9,7.1,2.5,8.6,4.5,17.4-12.7,20.6-3.2-2.6-10.1-5.5-11-9.2h0ZM465.1,2752.1c-22.7-2-20.9-18.7-15.1-27.9,11.9-19,38-20.8,62.3-15.8,15.8,3.3,26.5,13,26.4,27.7-19.8,15.4-46.7,18.5-73.6,16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2544.8,1448.8c-.5,2.5-.9,5-1,7.5-16.2,4.4-36.3,5.8-41.7-3.8l-174.8,15.3c-3.7,3.7-8.2,7.6-12.1,11.4-2.2,6.6-5,13.1-8.4,19.3-5.7,20.4-13.2,40.6-19.3,61l913.4-80c-4.7-8.3-2.2-19.5-.6-29.7,9.5-7.5,11.8-24.8,33.6-14.3,18.2,8.6,49.2,12.2,38.7,36.2-.2.5-.5,1-.7,1.5l679.5-59.5c4.7-29.9,8.9-59.8,15.1-89.5l-1421.6,124.5h0ZM2350.5,1506.9c0,1.5-5.3,2.8-8.2,4.4-1.3-4.5-3.3-8.5-3.2-12.3.2-1.3,5.7-2.5,8.6-3.7,1.2,3.9,3.2,7.8,2.8,11.6h0ZM2503.6,1506.3c-.5,10.2-10.1,14-23,14.3-15.1-1.5-17.5-10-18.5-18.7-1.3-12.1,10.8-13.5,22.7-13.2,14.2.5,19.2,8.4,18.8,17.6h0ZM3370.9,1462c-6.7,4-12.1,1.7-13.7-6.3-.3-1,6.2-3.4,9.8-3.7,2-.2,4.2,2.8,6.2,4.1-.7,2.1-.5,4.9-2.3,5.8h0ZM3790.3,1383.3c-.9-4.8-3.8-10.2-1.7-14.1,1.2-2.4,10.2-2.6,15.9-3.8.9,5,3.6,10.4,1.9,14.8-.7,2-10.4,2.1-16.1,3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1387.6,1637.1c-.3,0-.4.3-.6.4.3-.1.6-.2.6-.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1144.5,1809.2l-182.3,16.2-152,692.8,155.8-13.8,27.4-164.2,205.5-18.2,36.4,102.4c2.4-87.9,11.6-174.9,57.1-258.1l-147.9-357.1h0ZM1164.6,1986.4c2.2-3.5,13.1-7.3,17.8-6.1,11.1,2.9,23,8.7,13.3,19.3-3.5,3.8-12.6,4.8-19.2,7.1-14.7-3.4-17.1-11.6-11.9-20.3h0ZM895.8,2440.7c-4.2,8.6-12.7,14-26.6,11.3-17-7.9-11.9-19.3-7.2-29.6,3.2-7.1,7.5-18,22.8-11.5,15.6,6.6,16.7,18.3,11,29.8h0ZM1013.6,2219l10.3-61.6c-9,1.1-17.6,3.5-26,7.9-15.9,19.5-32,38.9-48.8,59.2-18.8-26.5-6-59.9,38.5-100,15.2-7.3,29.5-9.1,43.4-8,3.9-23.3,7.6-47.5,11.2-71.8-6.3-3.1-12.8-5.9-18.4-9.6-10.3-7-30.8-16.6-14.6-25.5,17.3-9.5,29.7-1.5,36.5,10.7,4.2-29.5,8.3-58.9,12.2-87.2l4.1-.4c12.3,34.7,24.7,71.9,37.2,108.6,13.4,7.7,23.7,19,29.5,36.1-6-.6-11.9-1.1-17.7-1.6,8.3,24,16.6,47.4,24.9,69.4l21.6,61-144.2,12.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1319.5,2231.7c-14.2,75-47.4,147.1-74.3,220.4l9.5,26.7,161.3-14.3-96.4-232.8h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1744.4,2447.9c50.8-4.5,93.9-16.8,129-37.5-21.5-2.5-30.2-10.1-28-17.9,4.9-18.2,21.2-33.1,47.1-33.5,10.6-.1,22.5,6,25.8,15.5,53-56.5,75-146.4,63.6-275l-.6-7.2c-7.6-12.7-8.1-25.3-3.3-36.9l-28.1-317.6-146.9,13,27.6,311.3c10.8-36.1,23.8-71.8,55.5-103.3-27.3,62.8-34.4,128.3-48.1,192.8,5.1,114.4-34.2,158.4-105.3,164.7-75.4,6.7-121-35.3-132.7-167.2l-33.4-377.3-152.4,13.5,32.1,361.7c20.1,226.3,123.8,316.3,298.2,300.9h0ZM1969,2147.5c11.7,37.2-4.2,56.7-27.9,82.3-10.2-31.3-.4-52.5,27.9-82.3ZM1467.8,1824c-3.4-.6-6.8-1-10.2-1.6,2.7-3.6,6.7-6.6,11.2-9.4-.3,3.7-.6,7.4-1,11.1h0ZM1525.3,2290.2c-.8,2-6.2,2.7-10.1,4.1-1.2-1.1-3.3-2.6-5.5-4.1,3.5-2.5,7.3-4.8,10.9-7.3,1.8,2.5,5.5,5.3,4.6,7.3h0ZM1652.5,2420.7c-1.3,2.9-12.4,6.7-15.9,5.4-8.8-3-10-10-3.2-15.4,3.7-3.2,10.7-4.5,16.4-6.8,1.3,5.9,4.6,12,2.7,16.8h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2474,1864.7l68.4-102.8c-63.2-52.6-147-76-224.7-69.1-28.5,2.5-55.1,8.6-79.2,17.6-18.8,25.9-7.3,59.7-18.3,87.9-14.9,37.9-13.5,81.1-61.6,111.7.4-49.4,5.2-98.3,14-146.6-20,29.2-43.7,59.4-73.2,93.8-4.3,18.5-5.8,37.9-4,57.7,8.7,97.9,79.9,149.5,152.3,171.7l80.5,26.2c-5.2-5.6-11.1-11-17.6-16.3,39.5-5.9,74.8-15.2,76.8-51.3-16.9-19.8-2.3-38.1,5.4-56.6,1.2-4.7,1.9-9.6,2.3-14.4l-36.3-11.1c-60.9-18.2-106.3-29.3-110-70.7-3.4-38.5,28.1-63.4,80.6-68.1,38.2-3.4,71.6,3.4,104.9,18.6,4.7-32.2,5.1-66.6,27.7-102.3,31.7,45,14,80.9-2.3,115.4,4.7,2.7,9.5,5.6,14.3,8.7h0ZM2185.5,1971.1c-1.4,1.7-2.9,2.4-4.4,3.6-9.8,7.7-22.3,5.5-35.2,2.2,6.5-20,1-45.1,40.2-51.4-5.2,8.9-6.2,17.8-5.5,26.7.5,5.6,1.8,11.1,4.4,16.6,1.7,0,3.4,0,5.2,0,.2.5.6.7.9,1.2-2.8.5-5.6,1-5.6,1h0ZM2225.5,1799.8l-.8-1.3c.2,0,.5,0,.8-.2,0,.5.1,1,0,1.5h0ZM2230,1866.3c.8.2,1.6.2,2.4.4.2.6.5,1.3.7,1.9-.4.5-1,.9-1.6,1.3-.2-1.2-1.2-2.5-1.5-3.6h0ZM2235.5,1996.8c-.2,0-.4-.1-.7-.2-.1.1-.3.1-.6.2-.5,0-.9-.1-1.3-.2.2-.1.4-.1.5-.3,0,0,.4.2.6.4-.1-.1-.3-.2-.4-.3.5,0,.6.2,1.1.3.2-.1.5-.2.7-.3,0,.2,0,.4,0,.5h0ZM2301.1,1968.5c1.3-.2,7.7,9.6,7.2,14.5-.7,8.4-2.5,17.6-17.9,20.4-3-2.8-9.6-6.2-10.3-10.1-2.4-12,2.9-22.1,21.1-24.8h0ZM2339.7,1813.8c-25.1-2.4-33.4-16-29.3-31.5,2.7-10.9,12.7-22.8,33.3-18.8,22.1,4.3,30.5,17.1,33.2,32.6-8.1,10.7-18.7,19.4-37.1,17.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2394.5,2383.9c5-7.4,14.8-12.2,28-6.5,2.5,1.1,4.7,2.3,6.7,3.6,116.9-33.7,176.9-124,168.5-219.2-3.5-39-14.9-70.5-33.1-95.8,2.3,29.6-32.7,53.2,12.5,80.6,35.6,21.6-21.5,47.7-42.5,71.3-57.1-79.7-64.8-90.3-5.8-139.1,2.1-11.6,7.2-23.6,14.7-36.7-24.9-23.4-57.4-40-95.8-51.7l-8.5-2.6c-7.9,20.9-18.3,41.5-22.8,62.8.6,29.3-11.5,56.5-23.4,83.8,29.5,11.7,47.5,25.7,50,53.7,3.3,36.9-21,63.4-74.6,71.7-3.6,9.1-7,18.3-9.4,27.6-8-8.4-12.2-16.8-14-25.4-53.4,1.8-113.9-20.8-162.8-56.3l-78.3,112.3c60.1,46.9,134.3,72.2,206.9,76.2-10-25.1-.4-48,21.9-71.9,22.8,22.7,29.4,43.8,15.6,67.2-.1,1.6-.2,3.2-.4,4.9,4.8-.2,9.6-.5,14.3-1,10.1-.9,19.8-2.1,29.3-3.7.7-1.8,1.7-3.7,3-5.6h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3173.3,1629.4l-155.8,13.8-51.7,321.1c-10,59.4-17.3,115-26.7,173.2,3.4-3.6,7.4-7.3,12-11.1,25.3,35.1,48.3,65.2,29.2,102.8-8.7-1.6-17.3-3.1-26.1-4.7-15.3-15.3-28.2-30.8-30.6-47.4-25.4-69.3-44.4-133.7-70-202.8l-109.1-306.9-161.3,14.3,58,144.4c4-4,8.9-7.9,14.6-11.6,4.8,13.5,5,25.7,2.1,36.9,15.4,5.9,27.7,22.8,44.8,27.9l-2.8,7.4-.4,3.9-.5,3.5c-2.4-.6-4.5-.3-7-.8-8.4-1.6-16.6-2.4-24.5-1.4l179,445.9,183.1-16.2,143.6-692h0ZM2800.8,1852.5c-7.7,27.5-7.3,59.2-56,69.1-11.2,3.2-22.6,6.5-33.9,10-7.3.5-14.4-.9-20.6-3.4,0,.2-.2.6-.3.9l-1.3-1.2c.5,0,1.2,0,1.6.3,1-5.6,2.2-11.1,3.8-16.5,1.8-5.9,3.6-11.7,5.4-17.5,15.7,1.2,24-4.8,28.5-14.9,16.2-15.3,23.8-37.9,58-37.2,5.3.1,15.5,7.6,14.8,10.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M3718.1,2131.7l-280.3,24.8-13.8-155.3,229.8-20.4-11.3-127.8-229.8,20.4-12-135.3,269.9-23.9-6.6-74.2c-21.8,8.6-38.1,19.4-43.4,40.7-2.8-63.5-3.7-82.3,39.9-80.6l-1.2-13.7-422.3,37.4,21.8,245.8c4.9-17.1,9.9-34.2,15-51.3,10.7-6.3,20.9-9.9,28.9-9.4-2.7-7.9,1.5-15.6,7.6-22.7,2.3-2.7,15.3-4.3,18.3-2.4,14.4,10.1,7.4,21.7-.4,31.9-1.5,1.8-6.4,2.2-11.3,2.5,1.4,3.1,2.2,7,2.4,11.8.8,27.4-23.2,40.5-60.4,40l37.9,427.8,432.7-38.3-11.3-127.8h0ZM3277.4,1733.3c-1.3,3.3-8.4,5.6-13.4,7.7-.6.2-6.9-4.8-6.4-5.7,3-4.5,7.5-8.5,12.3-13.4,2.9,4.1,8.5,8.4,7.4,11.4ZM3312.2,1683.9c-11.9-2.4-13.7-11-10-18.3,2.2-4.4,9.5-7.4,14.7-11,4.1,6.2,8.4,12.4,12.3,18.1-7.2,4.9-13.5,12-17,11.3h0ZM3311.4,1863.7c4.9-3.4,10-6.7,14.9-10.1,5.9,6.8,15,13.2,17.3,20.5,3.5,12.6-10.5,13.2-21.3,10.2-12.3-3.3-15.5-11.4-10.9-20.7h0ZM3374.6,2003.8c-9.8,12.5-19.2,25.1-34.1,44.3-25.9-23.3-35.8-41.4-13.7-63.4,9.4-9.2,21.7-20,38.9-15.8,27.8,6.8,19.6,21.2,8.9,34.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3904.1,1564.7l-74.4,6.6c-3.2,7.4-13,10.1-23.2,11.7-.6,0-1.3.1-1.9.2l25.9,292.6c5.6-54.7,10.2-109.5,40.4-161.2-15.2-46.3,13-87.4,28.7-129.9,2.4-6.5,3.7-13.3,4.5-20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M4325.3,1738.9c-14.2-160.3-135.8-199.5-278.7-186.8l-95.2,8.4c-7.6,24.8-12.4,49.8-10.9,75.4,1.6,28.6-26.3,41.1-35.9,62.4,6.5,42.5-40.1,85.8,5.1,128.2,5.2,4.9,3,20.4-3.4,24.7-48.3,31.7-42.6,79.8-67.3,118.4l24.6,278,152.4-13.5-21.5-242.6,83.8-7.4,79,121.6c4.9-7.8,15.9-9.2,24.1-1.4,7.1,6.7,9.6,15.2-2.6,20.7-2.2,1-4.7,1.6-7.5,2.1l52.6,81c5.8-5.2,14.4-9.5,27.3-12.8,0-.8,0-1.5,0-2.3l1.3,1.8c-.6.1-.7.4-1.4.5-.4,5.8,0,11.8.3,17.9l147.5-13.1-176.4-256c69.1-38.9,111.5-106.1,102.7-205.3h0ZM4232.6,1662.8c3.2-7.2,12.9-18.9,18.1-18.4,20.3,1.9,13.9,15.4,11.9,24.4-1.8,7.8-8.9,15.1-13.6,22.6-6.2-1.3-12.3-2.5-18.5-3.9.5-8.3-1.1-17.2,2.1-24.7h0ZM4206.9,1763.8c12.3,2.2,24.8,4.4,37,6.5.6,10.9.6,21.9,1.8,32.8,1.4,11.6-9.9,15.8-20,13.2-7.6-1.9-11.4-11.6-16.9-17.8,4.9-9.2,3.5-17.6-6.6-24.7,1.1-3.4,2.6-6.8,4.7-10h0ZM3983.7,1870.6l-16.8-189.5,78-6.9c80.2-7.1,125.2,11.3,131.1,78,5.9,66.3-34.1,104.4-114.3,111.5l-78,6.9h0ZM4211.9,2020.9c-3,3-11.8,2.8-18,4-11.8-14.4-7.5-28,3.7-40.4,2.7-2.9,16.1-4.6,17-3.5,10.9,13.5,9.8,27.5-2.7,39.9h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M4846.5,1484.7c1.4-1.5,2.8-2.8,4.1-3.9l-55.8,4.9h0c8.6,17.2,16.4,36.8,51.7-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M4786.1,1810.7c7.4-5.6,14.6-11.7,22.2-16.5l-26.2-36.2,180.1-287.1-91.7,8.1c6.7,4.9,10.5,14.8,9.5,20.4-7.3,40-20.2,79.4-31.9,122.8-57.8-6.2-83.4-23.1-85.6-71.1-.2-3.7-.3-7.4-.5-11.1l-48.9,81.2c3.5,2.8,6.7,6.1,9.7,9.1,9.2,9.1,19.1,17.8,28.8,26.7,12.8,14.3,1.8,19.9-15.5,19.4-18.7-.6-24.5-10-19.5-23-5.7-4.4-12.3-5.9-20-4.8l-6.9,11.5c-7.2,17.8-14.2,35.6-21.3,53.5.2.3.3.6.6.9,0,0-1.3.9-1.4,1h-.1s0,0,0,0c.3-.6.6-1.3.9-1.9-2.4-2.5-4.6-5-6.5-7.3l-43.8,72.7-3.8.3-24.4-275.4-152.4,13.5,59.7,674,152.4-13.5-16-180.6,69.5-111.1,189.1,270.2,167.1-14.8-208.1-287.9c-32.2-2.3-43.4-28.8-65.2-43h0ZM4810.8,1973.9c-5.5,3.6-13,8.5-20.4,13.3-2.4-5-6.8-10.1-6.7-15.1,0-8.2,2.1-19.1,15.5-19,12.3.1,11.7,10.5,11.6,20.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M6093.4,1138.2l-208.9,18.3c2.8,31.1-.4,60.4-6.6,88.8l271.4-23.8c3.5-33-24-54.9-55.8-83.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M6988.5,2146.4c20-2.7,30-9.2,35.1-17.7l-561.2,49.1c2.2,5.5,1.9,12.1-.7,16.9-6.9,12.5-23.6,18.4-38.6,6.2-10.1-8.2-18.4-13.8-25.5-17.4l-31.1,2.7c-5.1,6.9-8.1,17.9-11.2,30-5.5,21.4-18.3,40.2-27.7,60.2.2.5.3.9.4,1.4l664.5-58.2c-15.6-31.1-42-68.1-4.1-73.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M7991,2003l-78.3-894.8c-2.2-25.1-21.9-47-54.2-64.1,5.8,4.6,8.5,11.6,9.6,19.3,1,0,2,.1,3,.2l-2.4,1.3c0-.6-.4-.9-.6-1.5-14.8-.6-29.5-2-38.9-15.8-1.3-1.7,6.5-9.5,11.2-9.3,3.5.2,6.6.7,9.4,1.4-38.9-18.4-93.3-30.5-155.9-34.1-4.5,59.5-8.9,119-13.4,178.5h-.2c-3,.6-4.2,2.9-6.6,3.9l.4,6.7s-.1,0-.1,0c-4,1.1-8,2.2-12.1,3.3-2.9.8-6,1.5-8.9,2.3.7,1.2,1.3,2.4,2,3.6,1.6,2.6,3.1,5.4,4.7,8.1,3.7,6.8,7.7,13.6,11.3,20.4l-.7,2.6c.1,1.7.1,3.5.1,5.2-1.8.3-2.3,1.2-3.9,1.6-13.6,18.2-16.6,40.1-18.4,62.5-.4,4.3-.8,8.6-1.2,12.8l17.4,198.4c8.3-2.2,14.7,2.7,16.1,11.5,1.4,9.8.6,19.3-13.6,17.8l41,468.6c2.3,26.8-42.9,53.3-104.8,63.5-.7,5.1-1.5,10.4-2.2,15.7-1.6-5-3.1-9.9-4.6-14.7-5.8.8-11.8,1.5-17.9,2.1l-65.2,5.7c-1,2.3-1.9,4.6-2.9,6.9-1.4-2.1-2.7-4.2-4-6.3l-152.2,13.3c5,7.8,3.7,15.8-1.4,23.3-2.4,3.6-10.4,4.1-14.7,5.6-13.3-8.9-12.1-18.3-9.5-26.6l-88.6,7.8c-2.6,7.2-7.7,13.5-17.2,18.1-10.7,28.6,5.7,50,30.7,68.9l435-38.1c173.5-15.2,309.1-84.9,302.9-155.8h0ZM7396.4,2146.6c-.2-.2-.4-.3-.5-.4-.3,0-.5,0-.7-.1,0-.2,0-.4.2-.5.1.3.5.4.6.7.5.2.7.1,1.2.2-.2,0-.4.1-.5.2.3,0,.7-.1.8-.1,0,.2.2.3.3.5-.4,0-.9-.1-1.3-.4h0ZM7493.5,2165.3c-14.3-2.3-27.7-5.6-34.2-17.6-1-1.8-2.1-3.2-2.8-5.5,0,0-2.5-1.7-5.1-3.5.5-.4,1-.4,1.4-.8,1.8.8,3.5,1.5,5.2,2.3,5-4.4,8.7-9.3,11.6-14.7,4.6-8.6,7.5-18,6.2-29.1,36.4,23.4,19.9,46.1,17.7,68.9h0ZM7666.5,2136.2c-6-5.1-15-9.9-17.4-15.4-4.3-9.1.8-13.9,8.8-15.7,2.5-.4,3.9-2,7.3-1.7,5.5.6,15.5,8.9,16.3,13.3.2.4,0,1-.1,1.5,1.6,8.9-.3,17.7-14.9,18ZM7794.6,1401.5c18.8-3.4,18.6,9.4,20.6,17.6,3.1,11.9-6.5,15-18.9,15.1-12.7-2.3-23.1-8-24.5-18.8-1.8-12.8,12.5-12,22.8-13.9h0ZM7821.7,1575.1c-33.2-16-50.8-35.7-58.6-63.7,62,.4,74.1,22.9,58.6,63.7ZM7771.2,1815.4c-3.6-1-6.5-8.6-9.5-13,6.4-.6,13.2-3.2,19.5-1.4,4.2,1.1,7.4,8.2,10.9,12.9-7.4.6-14.2,2.9-20.9,1.4h0ZM7892.4,2044.8c-2.9-2.9-8.2-6.3-8.2-8.7,0-2.4,5.3-3.9,8.4-5.7,2.7,2.9,8.2,6.3,8.2,8.7-.2,2.4-5.5,3.8-8.4,5.7ZM7873.6,1767c1.6,13.1,10.5,32.5,3,37.9-13.8,10.3-29.8-8.3-41.2-17.5-12.5-10-20.6-23.8-30.7-36-19.6-10.1-22.7-23-18.7-37.2-14.8-17.1-18.4-31.6-11.9-43.9-2.4-4.3-4.1-9.3-6.2-13.9-3.5-7.7-7.2-15.7-8.6-22.7-3.6.9-8,1.6-12.6,3.1-2.3-10.9-6.6-20.9-5.7-29.5.4-5.1,12.5-12.2,13.7-11.5,8.6,5.5,13.4,11.6,14.9,17.9,3.1-1.2,6.8-2.2,11.5-2.8,10.2-1.4,18.1,2,24.1,7.3,10.4-30.5,22.4-62.5,71.6-81.1,2.2,85.6,56.3,167-3.2,230h0ZM7905.8,1490.9c-13.1,15.9-29.2-1.4-41.1-9.6-8.4-5.8-13.6-14.9-19.8-23.2-.4-.6-.8-1.2-1.2-1.9-.5-.4-.7-.9-1-1.4-.8,0-1.4,0-2.1.2h0c.3,0,1.9-.4,1.9-.4.1,0,.1.2.2.3h.1c5.4-.6,11-1.1,16.5-1.4,1.6-.1,3.3-.4,4.8-.4,14.6.2,32.2-10.2,42.7,10.3,4.4,8.5,4.2,21.1-.9,27.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M4500,1365.8c-3-2.4-6.2-4.8-9.2-7.2,2.8-1.3,7.2-4.1,8.6-3.5,4.3,1.8,7.8,5.1,11.6,7.8-1.7.8-3.5,1.5-5.3,2.4l187.6-16.4c.7-.8,1.4-1.6,2-2.4,7,0,13.9.1,20.7.5l44-3.9c-.6-2.3-1-4.7-1.1-7-.2-4.9,6.3-8.8,9.9-13.1,8.1,5.8,19.3,10.9,24.7,17.2l44.9-3.9c.4-2,1.1-4.1,2.1-6.2,1-2.2,9.5-3.5,10.7-2.4,2.6,2.3,4.7,4.7,6.3,6.9l392-34.3c-11.2-4.2-13.8-12.8-13.1-22.9.8-11.7,5.4-25.5,21.8-25.3,16.8.2,21,14.6,22.5,26.2,1.2,8.6-.5,15.7-8,20l134.1-11.7c1.8-8.5,7.5-15.4,17.2-20.5,1.3-.7,14,6.9,15.4,10.9.7,2.2,1.4,4.4,1.9,6.6l348.1-30.5c1.6-4,4.1-7.2,7-8.3,44.3-15.8,44.5-51.3,48.9-84.8l-990.1,86.7c0,.9,0,1.8-.3,2.5-3,8.8-10.1,15.9-25.5,11.3-2.2-3.5-6.8-7.6-7.9-10.8l-11.3,1c-5.2,5.7-13.5,8-23.6,7.3-6.7-.4-12.4-1.8-17.1-3.8l-755.8,66.2c-9.4,30.2-22.6,60.1-28.5,90.7h0s515.1-45.1,515.1-45.1h0ZM4942.1,1282.4c.8-8.9,8-16,21.9-11.5,9.1,2.9,9.4,9.5,3.3,15.6-5.7,3.8-11.6,7.5-17.4,11.2-2.8-5.1-8.1-10.4-7.7-15.3h0ZM4810.1,1293.2c1.2-8,2.6-18.4,16.6-18.6,13.4-.2,14.5,9.2,13,16.9-1.6,8-3.5,16.6-17,19.2-13.4-2.2-13.7-10.1-12.5-17.5h0ZM4326.9,1311.1c11.2,2.6,25.3,11.4,16.9,16-19.5,10.6-44.3,15.8-66.9,23.2-2.5-8-4.9-16.1-6.2-20.8,9.7-28.1,32.7-23.9,56.2-18.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7077.7,2124c18.6,44.5,7.9,59.6-44.3,92.1l144.5-12.6c.1-28.7,1.3-57.1,13.2-82.8.4-2.2.8-4.4,1.2-6.6l-114.5,10h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M7299.5,1044.5c4.2,10.3,3,20.4-9.4,23.6-2.9.8-13.6-6.2-15.7-10.5-5.1-10.2-1.3-18.2,8.8-23.6l-1126.9,98.7c29.2,15.7,20.2,35.8-5.7,88.7l441.4-38.6c-2.5-4.5-4-9.3-4-14.3,0-28.7,32.5-18.6,54.5-19.3,24.9-.9,21.6,15.3,26.4,26.9l545-47.7c-4.6-5-7.3-11.1-7.4-18.2-.2-20.7,13.4-40.7,42.1-33.9,13.8,3.3,30.9,27.9,37,43.6.3.7.5,1.4.7,2.1l206.3-18.1c74.2-6.5,136.4,12.8,139.1,43.1l.7,7.6c0-.1,0-.2.1-.3h.1c-.1,0,0,0-.1,0,10.2-49.8,20.3-99.7,30.4-149.6-24.3-.3-49.7.6-75.7,2.9l-301.5,26.4c5,3.4,12.1,6.7,13.8,10.7h0ZM6423.9,1185.9c-1.8.8-5.4-.8-8.4-1.3-1.3-2.5-4.4-5.9-3.7-7.3,1.3-2.5,6.7-5.9,7.9-5.2,10.3,5.8,11.8,11.1,4.2,13.8h0ZM6510.3,1115.3c-5.1,7.3-11.4,7.2-16.4.3-1.4-1.8,0-4.4.3-6.8,2.5-.5,6.1-2.4,8-1.4,3.5,1.9,8.8,7.1,8.2,8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M7832.5,1687c-20.3-2.2-12.4,13.3-15.4,22.1h.1c8,4.7,15.7,5.6,22.8,2.5-2.6-8.6-5.9-24.5-7.5-24.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M5749.8,2328.2c2.6-1.5,5.9-5,7.5-4.3,2.3.9,4.4,2,6.5,3.3l408.1-35.7c-11.9-4.3-15.9-12.4-16.9-22.3,18.1,1.7,23.6,9.9,22.4,21.8l128.8-11.3c.8-2.5,1.5-5.1,2.3-7.6,1.2-27.4,3.7-54.5,7.1-81.4l-138.2,12.1c2.2,2.8,3.9,5.8,4.9,9.4-8.1-1.2-13.6-4.2-17.8-8.3l-1142.7,100c-.2,1.3-.5,2.6-.8,3.9-1.3,4.7-10.4,11.7-15.9,11.7-18.8,0-30-4.1-37.5-10.9l-312.2,27.3c-1.5,5.4-9.2,10.4-18.1,9.5-7.4-.7-13.5-3-18-6.4l-1505.9,131.8c-3.5,10.2-7.2,20.4-11.1,30.6-1.3,11-2.7,21.9-4.1,32.8,7.4,8.6,8.8,17,7.7,25.4l964.3-84.4c-6.2-3.7-9.4-8.6-2.1-17.3,9.5-11.1,32.4-27.5,41.4-25.2,22.9,5.9,25.1,21.4,19.6,37.3l196.4-17.2c9.9-6.9,25.1-10.6,40.7-14,0-.6.2-1.2.2-1.7l1,1.4c-.4.1-.8.2-1.2.3-.4,2.2-.8,4.5-1.2,6.8-.1,1.3-.2,2.5-.3,3.8l389.8-34.1c-2.4-2.4-4.6-5-6.7-7.5,34.8-17.1,77.6-9.2,115.3-18.7,22.1-5.5,48.2-4.1,56.8,11.8l830.3-72.7c-.1,0-.2-.1-.3-.2h0ZM3230.2,2497.7c8.4-9.8,21.8-10.9,35.8-11.2-10.3,6.5-18.9,15.9-35.8,11.2ZM3337.6,2499.7c-1.8,4.3-9.6,7.2-14.8,10.8-1.6-5-6-10.6-4.3-15,1.7-4.1,9.4-6.9,14.6-10.3,1.7,4.9,6.3,10.4,4.5,14.4h0ZM3352.3,2501.7c-13.8-2.7-18.5-9.5-15.9-19.6,18.9.6,22.4,8,15.9,19.6ZM3610.3,2445.2c-2.1,8-8.9,15.4-21.9,13.4-3.1-.5-3.6-9.8-5.4-15.1,3.7-8,9.6-15.3,22.4-13.2,3.2.6,6,10.1,4.8,14.9h0ZM3629.7,2478.4c-2.2-.5-5.5-.6-6.6-1.7-4.7-4.7-1.7-8.3,7.8-9.5,1,0,4.1,4.3,4.1,6.6,0,1.5-3.4,3.1-5.4,4.6h0ZM3805,2448.2c-5,2.4-10.5,4-16,5.9-2.8-3.8-5.7-7.7-8.3-11.5,6.8-.6,13.7-1.7,20.5-1.4,1.6,0,4.4,6.7,3.8,7.1ZM3853.7,2462c49.5-40.2,92.4-33.7,142.7,8.4-51.4,13-96,20.9-142.7-8.4ZM4649.5,2394.5c-1.7-2.5-3.5-5-5.4-7.5,3.5-1.3,7.5-4,10.2-3.4,2.7.6,3.7,4.6,5.5,7.1-3.4,1.3-6.8,2.5-10.3,3.8ZM5639.3,2287.5c-2,.7-5.6-1.1-8.5-1.7-1.2-2.3-4.3-5.7-3.5-7,1.6-2.4,6.9-5.5,8.1-4.8,10.1,5.9,11.4,11.1,3.9,13.5h0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampsold01);
export default __webpack_public_path__ + "static/media/stampsold01.c01756d9c61ca2a2f8d0cb4d939570f5.svg";
export { ForwardRef as ReactComponent };